import { render } from "./Sclavo.vue?vue&type=template&id=116e6502&scoped=true"
import script from "./Sclavo.vue?vue&type=script&lang=js"
export * from "./Sclavo.vue?vue&type=script&lang=js"

import "./Sclavo.vue?vue&type=style&index=0&id=116e6502&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116e6502"]])

export default __exports__